export enum DashboardType {
  PICKING = 'picking',
  PACKING = 'packing',
}
